import { Stack } from '@mantine/core';
import ProjectRole from '@projectMembers/models/projectRole';
import Project from 'src/entities/project';
import useProjectMembersList from './useProjectMembersList';
import ProjectMemberListItem from './ProjectMemberListItem/ProjectMemberListItem';
import ProjectInvitationListItem from './ProjectInvitationListItem/ProjectInvitationListItem';

export type ProjectMembersListProps = {
	project: Project;
	currentUserRole: ProjectRole;
	currentUserID: number;
};

const ProjectMembersList = ( { project, currentUserRole, currentUserID }: ProjectMembersListProps ) => {
	const {
		members,
		invitations,
		roleOptions,
		canEditProjectMember,
		canDeleteProjectMember,
		canDeleteProjectInvitation,
		onDeleteProjectMember,
		onUpdateProjectMemberRole,
		onDeleteProjectInvitation
	} = useProjectMembersList( { project, currentUserRole } );

	return (
		<Stack style={{ height: 'fit-content' }}>
			{members.map( member => (
				<ProjectMemberListItem
					key={member.id}
					member={member}
					roleOptions={roleOptions}
					isCurrentUser={currentUserID === member.user.id}
					readonly={!canEditProjectMember( member )}
					showDelete={canDeleteProjectMember( member )}
					onDelete={onDeleteProjectMember}
					onUpdateRole={onUpdateProjectMemberRole}
				/>
			) )}
			{invitations.map( invitation => (
				<ProjectInvitationListItem
					key={invitation.id}
					invitation={invitation}
					showDelete={canDeleteProjectInvitation( invitation )}
					onDelete={onDeleteProjectInvitation}
				/>
			) )}
		</Stack>
	);
};

export default ProjectMembersList;
